import { render, staticRenderFns } from "./createBox.vue?vue&type=template&id=3134599b&scoped=true"
import script from "./createBox.vue?vue&type=script&lang=js"
export * from "./createBox.vue?vue&type=script&lang=js"
import style0 from "./createBox.vue?vue&type=style&index=0&id=3134599b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3134599b",
  null
  
)

export default component.exports